import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import { updateUser } from 'auth/store/users/actions';
import { getEditingUser } from 'auth/store/users/selectors';
import { closeModal } from 'modal/store/actions';
import {
  fetchContactByUserId,
  updateContact,
} from 'contacts/store/actions';
import {
  getEditingUserContactIsLoading,
  getEditingUserContact,
} from 'contacts/store/selectors';
import ContactForm from 'contacts/containers/modal/ContactForm';
import UserForm from './UserForm';

class UpdateUserModal extends React.Component {
  componentDidMount() {
    const { fetchContactByUserId, user } = this.props;
    fetchContactByUserId(user.id);
  }

  render() {
    const {
      name, user, updateUser, closeModal, contact, isLoading, updateContact,
    } = this.props;

    const form = contact
      ? (
        <ContactForm
          contact={contact}
          isAdminForm
          onSubmit={(contactValues) => {
            const updatedContact = {
              ...contact,
              ...contactValues,
            };
            updateContact(updatedContact);
            closeModal(name);
          }}
        />
      )
      : (
        <UserForm
          user={user}
          onSubmit={(user) => {
            updateUser(user);
            closeModal(name);
          }}
        />
      );

    return (
      <>
        <MainTitle withSpaceBelow>Edit User</MainTitle>

        {isLoading ? 'Loading...' : form}

      </>
    );
  }
}
UpdateUserModal.propTypes = {
  name: PropTypes.string.isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  updateUser: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  updateContact: PropTypes.func.isRequired,
  fetchContactByUserId: PropTypes.func.isRequired,
  contact: PropTypes.objectOf(PropTypes.any),
  isLoading: PropTypes.bool.isRequired,
};
UpdateUserModal.defaultProps = {
  contact: null,
};

const mapStateToProps = (state) => ({
  user: getEditingUser(state),
  isLoading: getEditingUserContactIsLoading(state),
  contact: getEditingUserContact(state),
});
const mapDispatchToProps = {
  updateUser,
  closeModal,
  updateContact,
  fetchContactByUserId,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateUserModal);
